module.exports = __webpack_public_path__ + "img/img1.0b0c96d5.png";